import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Grid } from '@material-ui/core';
import Tooltip from "@material-ui/core/Tooltip";

import { toGermanFormat } from '../../../../../../../../utils/numberFormater'

import useStyles from './styles'

function ExAnteAverageLine(props) {

  const {
    title,
    numbersTooltip,
    euroValue,
    percentValue,
    averageValue,
    footer=false
  } = props;

  const classes = useStyles();

  const avgValueFormatted = (averageValue || averageValue == 0) ? toGermanFormat(averageValue, undefined, ' €') : '';

  return (
    <Grid item xs={12} className={clsx(classes.lineWrapper, classes.withBorder, footer && classes.footer)}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <span className={clsx(classes.label, footer && classes.textBold)}>{ title }</span>
        </Grid>
        <Grid item xs={3}>
          <span className={clsx(classes.label, classes.alignRight, footer && classes.textBold)}>
            { (percentValue || percentValue == 0) ? toGermanFormat(percentValue * 100, undefined, ' %') : '' }
          </span>
        </Grid>
        <Grid item xs={3}>
          <span className={clsx(classes.label, classes.alignRight, footer && classes.textBold)}>
            { (euroValue || euroValue == 0) ? toGermanFormat(euroValue, undefined, ' €') : '' }
          </span>
        </Grid>
        <Grid item xs={3}>
          <span className={clsx(classes.label, classes.alignRight, footer && classes.textBold)}>
            {numbersTooltip ? (
              <Tooltip
                classes={{tooltip: classes.tooltip}}
                title={numbersTooltip}
                placement={"top"}
                arrow>
                <span>{ avgValueFormatted }</span>
              </Tooltip>
            ) : (
              <>{ avgValueFormatted }</>
            )}
          </span>
        </Grid>
      </Grid>
    </Grid>
  )
}

ExAnteAverageLine.propTypes = {
  /** Line title */
  title: PropTypes.string.isRequired,

  /** Value in EUR */
  euroValue: PropTypes.number.isRequired,

  /** AVG Value in EUR */
  averageValue: PropTypes.number.isRequired,

  /** Value in % */
  percentValue: PropTypes.number.isRequired
};

export default ExAnteAverageLine

